import * as config from "../config.js";

export const getEmailCampaigns = async () => {
  const url = `${config.REST_SERVER_URL}/admin/emailcampaign`;
  try {
    const response = await fetch(url, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    });

    const results = await response.json();
    return results;
  } catch (error) {
    console.log(`Error fetching email campaigns: ${error.message}`);

    return {
      success: false,
      message: `Error fetching email campaigns: ${error.message}`,
    };
  }
};

export const getEmailCampaign = async (public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/emailcampaign/${public_id}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    });

    const results = await response.json();
    return results;
  } catch (error) {
    console.log(`Error fetching email campaign: ${error.message}`);

    return {
      success: false,
      message: `Error fetching email campaign: ${error.message}`,
    };
  }
}

export const saveEmailCampaign = async (emailCampaign) => {
  const method = emailCampaign.public_id ? "PUT" : "POST";
  const id = emailCampaign.public_id ? `/${emailCampaign.public_id}` : "";
  const url = `${config.REST_SERVER_URL}/admin/emailcampaign${id}`;
  try {
    const response = await fetch(url, {
      method: method,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify(emailCampaign),
    });

    const results = await response.json();
    return results;
  } catch (error) {
    console.log(`Error saving email campaign: ${error.message}`);

    return {
      success: false,
      message: `Error saving email campaign: ${error.message}`,
    };
  }
}

export const addEmailCampaignRecipients = async (public_id, recipients) => {
  const url = `${config.REST_SERVER_URL}/admin/emailcampaign/add-recipients/${public_id}`;
  try {
    const response = await fetch(url, {
      method: "POST",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
      body: JSON.stringify({ recipients }),
    });

    const results = await response.json();
    return results;
  } catch (error) {
    console.log(`Error adding email campaign recipients: ${error.message}`);

    return {
      success: false,
      message: `Error adding email campaign recipients: ${error.message}`,
    };
  }
}

export const deleteEmailCampaignRecipient = async (public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/emailcampaign/remove-recipient/${public_id}`;
  try {
    const response = await fetch(url, {
      method: "DELETE",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    });

    const results = await response.json();
    return results;
  } catch (error) {
    console.log(`Error deleting email campaign recipient: ${error.message}`);

    return {
      success: false,
      message: `Error deleting email campaign recipient: ${error.message}`,
    };
  }
}

export const getEmailCampaignCounts = async (public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/emailcampaign/counts/${public_id}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
      }, credentials: "include",
    });

    const results = await response.json();
    return results;
  } catch (error) {
    console.log(`Error fetching email campaign counts: ${error.message}`);

    return {
      success: false,
      message: `Error fetching email campaign counts: ${error.message}`,
    };
  }
}
